import { default as throttle } from 'lodash.throttle';
import { useLayoutEffect, useState } from 'react';

import { browserConfig } from '../../configs/BrowserConfig';

/**
 * Window resize listener for getting true/false if virtual keyboard is open.
 * Works only for mobile devices, for desktop always returns false.
 */
export function useIsKeyboardOpen(minKeyboardHeight: number = 300): boolean {
  const [isKeyboardOpened, setIsKeyboardOpened] = useState<boolean>(false);

  useLayoutEffect(() => {
    if (browserConfig.BROWSER?.isMobile && 'visualViewport' in window) {
      const onResize = throttle(() => {
        setIsKeyboardOpened((isKeyboardOpened) => {
          const newIsKeyboardOpened: boolean =
            window.screen.height - minKeyboardHeight > window.visualViewport!.height;
          if (isKeyboardOpened !== newIsKeyboardOpened) {
            return newIsKeyboardOpened;
          }

          return isKeyboardOpened;
        });
      }, 100);

      window.visualViewport!.addEventListener('resize', onResize);

      return () => {
        window.visualViewport!.removeEventListener('resize', onResize);
      };
    }
  });

  return isKeyboardOpened;
}
